import approvalProgress from '@/components/approvalProgress'
import wx from 'weixin-js-sdk'
import storage from './../../utils/storage'
import { doInstance, queryAttachmentListByOneData } from '@/utils/api'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      tabs: [
        {
          title: '基本信息'
        },
        {
          title: '审批内容'
        },
        {
          title: '审批流程'
        }
      ],
      activeTab: 0,
      scroll: {},
      myDataObj: {
        businessData: {}
      },
      edit: false,
      showShadow: false,
      markContent: '',
      companyId: storage.get('companyId'),
      approveFileArr: []
    }
  },
  created() {
    this.loadOneInnstance()
  },
  methods: {
    ...mapMutations(['actionLoadingToast']),
    doInstance(status) {
      this.actionLoadingToast({
        show: true,
        title: '审批中'
      })
      let timestamp = new Date().getTime()
      doInstance({
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.myDataObj.id,
        bsid: this.myDataObj.bsid,
        approvalResults: Number(status),
        comments: this.markContent,
        approverId: this.userInfo.userInfo.id
      }).then(() => {
        this.edit = false
        this.actionLoadingToast({
          show: false
        })
        this.loadOneInnstance()
        this.$router.push({
          name: 'success'
        })
      })
    },
    changeTab(index) {
      this.activeTab = index
      switch (index) {
        case 0:
          this.scroll.scrollTo(0, 0)
          break
        case 1:
          this.scroll.scrollTo(0, -200)
          break
        case 2:
          this.scroll.scrollToElement(document.querySelector('.approveCard'))
          break
        default:
      }
    },
    /*获取审批附件函数*/
    getApproveFileFn() {
      if (!this.$route.query.id) return
      queryAttachmentListByOneData({
        target: this.$route.query.id,
        moduleCode: 'BPM'
      }).then(res => {
        this.approveFileArr = res.data
      })
    },
    showFilepage(item) {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') > -1) {
        wx.miniProgram.navigateTo({
          url:
            '/pages/showFilePage/index?returnUrl=' +
            encodeURIComponent(item.path) +
            '&displayName=' +
            encodeURIComponent(item.displayName)
        })
      }
    }
  },
  filters: {
    itemFilter: (value, filterArr, allSelect) => {
      for (let index in allSelect[filterArr])
        if (allSelect[filterArr][index].code == value) {
          return allSelect[filterArr][index].text
        }
    },
    timeFilter: ts => {
      var dd = parseInt(ts / 60 / 60 / 24, 10) //计算剩余的天数
      var hh = parseInt(ts / 60 / 60 % 24, 10) //计算剩余的小时数
      var mm = parseInt(ts / 60 % 60, 10) //计算剩余的分钟数
      var ss = parseInt(ts % 60, 10) //计算剩余的秒数
      return dd + '天' + hh + '小时' + mm + '分' + ss + '秒'
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'sence', 'allSelect']),
    businessData: function() {
      return JSON.parse(this.myDataObj.businessData)
    }
  },
  components: {
    approvalProgress
  }
}
